var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EFF3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 24.9999V20.6257C35 19.5861 35 19.0662 34.781 18.7467C34.5896 18.4676 34.2933 18.278 33.9597 18.2213C33.5779 18.1563 33.1059 18.3741 32.1619 18.8098L21.0738 23.9274C20.2319 24.316 19.8109 24.5102 19.5026 24.8116C19.2301 25.0779 19.022 25.4031 18.8944 25.7622C18.75 26.1684 18.75 26.632 18.75 27.5592V33.7499M35.625 33.1249H35.6375M18.75 28.9999L18.75 37.2499C18.75 38.65 18.75 39.3501 19.0225 39.8849C19.2622 40.3553 19.6446 40.7377 20.115 40.9774C20.6498 41.2499 21.3499 41.2499 22.75 41.2499H37.25C38.6501 41.2499 39.3502 41.2499 39.885 40.9774C40.3554 40.7377 40.7378 40.3553 40.9775 39.8849C41.25 39.3501 41.25 38.65 41.25 37.2499V28.9999C41.25 27.5998 41.25 26.8997 40.9775 26.3649C40.7378 25.8945 40.3554 25.5121 39.885 25.2724C39.3502 24.9999 38.6501 24.9999 37.25 24.9999L22.75 24.9999C21.3499 24.9999 20.6498 24.9999 20.115 25.2724C19.6446 25.5121 19.2622 25.8945 19.0225 26.3649C18.75 26.8997 18.75 27.5998 18.75 28.9999ZM36.25 33.1249C36.25 33.4701 35.9702 33.7499 35.625 33.7499C35.2798 33.7499 35 33.4701 35 33.1249C35 32.7797 35.2798 32.4999 35.625 32.4999C35.9702 32.4999 36.25 32.7797 36.25 33.1249Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF5);
export default __webpack_public_path__ + "static/media/f5.7fe0cc30debeb09b3b37c60169f77f51.svg";
export { ForwardRef as ReactComponent };